var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2853_3607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.59912 12H8.59912L9.09912 16H7.09912L7.59912 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09912 12C8.09912 10.6667 8.09912 7.4 8.09912 5C8.09912 2.6 10.0991 1.5 11.0991 1.5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09912 12C8.09912 10.6667 8.09912 7.4 8.09912 5C8.09912 2.6 6.09912 1.5 5.09912 1.5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0991 1H14.5991V2H11.0991V1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59912 1H5.09912V2H1.59912V1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59912 3L1.09912 4.5",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5991 3L11.0991 4.5",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09912 3V5",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0991 3V5",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59912 3L5.09912 4.5",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5991 3L15.0991 4.5",
    stroke: "black",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2853_3607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.ba2cd9c2cf56abb85d3f119950cbb19a.svg";
export { ForwardRef as ReactComponent };